module.exports = __webpack_public_path__ + "static/media/l.9eb9b740.svg";